// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2qRF6","modalForm":"UpgradeEpcsModal_modalForm__2BAKy","modalFooter":"UpgradeEpcsModal_modalFooter__3grKK"};